import _ from "underscore";
import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";

function makeIntoObject(list) {
  return _.object(_(list).pluck("value"), _(list).pluck("text"));
}

export const mutations = {
  [mutation.LOAD_STATIC_LOOKUPS_STARTED](state) {
    state.loading = true;
  },
  [mutation.LOAD_STATIC_LOOKUPS_SUCCEEDED](state, data) {
    stateMerge(state.data, data);
    state.data.applicationStatusDescriptions = makeIntoObject(data.applicationStatuses);
    state.data.assignedPaymentStatusDescriptions = makeIntoObject(data.assignedPaymentStatuses);
    state.data.contactPositionDescriptions = makeIntoObject(data.contactPositions);
    state.data.contactStatusDescriptions = makeIntoObject(data.contactStatuses);
    state.data.contactTypeDescriptions = makeIntoObject(data.contactTypes);
    state.data.estimatorTemplateTypeDescriptions = makeIntoObject(data.estimatorTemplateTypes);
    state.data.invoiceStatusDescriptions = makeIntoObject(data.invoiceStatuses);
    state.data.jobFrequencyUnitDescriptions = makeIntoObject(data.jobFrequencyUnits);
    state.data.jobTypeDescriptions = makeIntoObject(data.jobTypes);
    state.data.levyCollectionProviderStatusDescriptions = makeIntoObject(data.levyCollectionProviderStatuses);
    state.data.levyCollectionProviderWarningTypeDescriptions = makeIntoObject(data.levyCollectionProviderWarningTypes);
    state.data.levyCollectionStatusDescriptions = makeIntoObject(data.levyCollectionStatuses);
    state.data.levyCollectionTypeDescriptions = makeIntoObject(data.levyCollectionTypes);
    state.data.loanTypeDescriptions = makeIntoObject(data.loanTypes);
    state.data.manualFinalisationReasonDescriptions = makeIntoObject(data.manualFinalisationReasons);
    state.data.noticeTypeDescriptions = makeIntoObject(data.noticeTypes);
    state.data.organisationClassificationDescriptions = makeIntoObject(data.organisationClassifications);
    state.data.organisationOwnershipDescriptions = makeIntoObject(data.organisationOwnerships);
    state.data.overrideCategoryDescriptions = makeIntoObject(data.overrideCategories);
    state.data.overrideTypeDescriptions = makeIntoObject(data.overrideTypes);
    state.data.paymentStatusDescriptions = makeIntoObject(data.paymentStatuses);
    state.data.permissionCategoryDescriptions = makeIntoObject(data.permissionCategories);
    state.data.permissionClaimTypeDescriptions = makeIntoObject(data.permissionClaimTypes);
    state.data.providerContactSectorDescriptions = makeIntoObject(data.providerContactSectors);
    state.data.providerTaskTypeDescriptions = makeIntoObject(data.providerTaskTypes);
    state.data.riskFactorTypeDescriptions = makeIntoObject(data.riskFactorTypes);
    state.data.scheduledJobStatusDescriptions = makeIntoObject(data.scheduledJobStatuses);
    state.data.sapReconciliationWarningTypeDescriptions = makeIntoObject(data.sapReconciliationWarningTypes);
    state.data.systemLogActionDescriptions = makeIntoObject(data.systemLogActions);
    state.data.levyCollectionTaskTypeDescriptions = makeIntoObject(data.levyCollectionTaskTypes);
    state.data.userStatusDescriptions = makeIntoObject(data.userStatuses);
    state.data.mfaChallengeOutcomeStatusDescriptions = makeIntoObject(data.mfaChallengeOutcomeStatuses);
    state.data.mfaAuthenticationMethodDescriptions = makeIntoObject(data.mfaVerificationMethods);
    state.data.mfaOperationModeDescriptions = makeIntoObject(data.mfaOperationModes);
    state.lastRefreshed = new Date();
    state.loading = false;
    state.loaded = true;
  },
  [mutation.LOAD_STATIC_LOOKUPS_FAILED](state) {
    state.loading = false;
    state.loaded = false;
  },

  [mutation.LOAD_DYNAMIC_LOOKUPS_STARTED](state) {
    state.loading = true;
  },
  [mutation.LOAD_DYNAMIC_LOOKUPS_SUCCEEDED](state, { allLevyCollections, currentLevyCollections, roleCodes }) {
    state.loading = false;
    state.data.allLevyCollections = allLevyCollections;
    state.data.currentLevyCollections = currentLevyCollections;
    state.data.roleCodeDescriptions = makeIntoObject(roleCodes);
    state.data.roleCodes = roleCodes;
  },
  [mutation.LOAD_DYNAMIC_LOOKUPS_FAILED](state) {
    state.loading = false;
  }
};
